var _defs, _path, _path2, _path3, _rect, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    strokeWidth: 1,
    width: 29,
    height: 29,
    color: "#FFFFFF",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5d3-1{fill:none;stroke:currentColor;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6374f543b67f094e4896c5d3-1",
    d: "M15.93,10a2.85,2.85,0,0,1,0,4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6374f543b67f094e4896c5d3-1",
    d: "M18,8a5.72,5.72,0,0,1,0,8.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6374f543b67f094e4896c5d3-1",
    d: "M20,5.93a8.57,8.57,0,0,1,0,12.14"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6374f543b67f094e4896c5d3-1",
    x: 1.5,
    y: 8.18,
    width: 4.77,
    height: 7.64
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6374f543b67f094e4896c5d3-1",
    points: "13.91 3.41 13.91 20.59 12.24 20.59 6.27 15.82 6.27 8.18 12.24 3.41 13.91 3.41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighVolume);
export default __webpack_public_path__ + "static/media/high-volume.81e91f5b9b0593807ec5e9a34700ba4f.svg";
export { ForwardRef as ReactComponent };